/* eslint-disable */
<template>
  <div>
    <div class="container-fluid w-100 no-padding">
      <div class="row bg-primary-dark">
        <div class="col-md-4 mb-2 mt-2 align-middle d-flex flex-row">
          <h4 class="mr-4">Müşteri - Luca Hesap Eşleşmeleri</h4>
        </div>
        <div class="col-md-8 mb-2 mt-2 align-middle d-flex flex-row items-center justify-content-end">
          <div v-for="(star, index) in starCounts" :key="'star-' + index" class="mr-2 border rounded nav-link align-middle">
            <span v-if="index == 0">👑🥇</span>
            <span v-if="index == 1">🥈</span>
            <span v-if="index == 2">🥉</span>
            <span style="font-weight: 700;">{{star.personel}}</span>
            <span class="ml-1 badge bg-warning text-white" style="font-weight: 700; font-size: 0.875em;">{{star.count}}</span>
          </div>
          <button class="btn btn-more-radius btn-success float-right" data-toggle="modal" data-target="#uetdsModal">Yeni Kayıt Ekle</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-wait for="lcc-data-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Veriler yükleniyor...</p>
              </div>
            </template>
            <table class="table table-bordered table-striped table-hover">
              <thead class="thead-light">
                <tr>
                  <th style="width: 32px;" scope="col">#</th>
                  <th style="width: 10%;" scope="col">BAYİİ</th>
                  <th style="width: 5%;" scope="col">MÜŞTERİ KODU</th>
                  <th style="width: auto;" scope="col">MÜŞTERİ ADI</th>
                  <th style="width: 8%;" scope="col">MÜŞTERİ V.D. (A1)</th>
                  <th style="width: 8%;" scope="col">MÜŞTERİ V.N. (A1)</th>
                  <th style="width: 8%;" scope="col">LUCA HESAP KODU</th>
                  <th style="width: 8%;" scope="col">KAYDEDEN</th>
                  <th style="width: 8%;" scope="col">KAYIT TARİHİ</th>
                  <th style="width: 15%;" scope="col">KOMUTLAR</th>
                </tr>
              </thead>
              <tbody class="tbody-margin">
                <template v-for="(lcc, index) in lccData">
                  <tr :key="'trow-first-' + lcc.index">
                    <td class="align-middle text-center">{{lcc.ID}}</td>
                    <td class="align-middle text-center">{{lcc.RETAILER_NAME}}</td>
                    <td class="align-middle text-center">{{lcc.CUSTOMER_ID}}</td>
                    <td class="align-middle text-left">{{lcc.CUSTOMER_TITLE}}</td>
                    <td class="align-middle text-center">{{lcc.CUSTOMER_VD}}</td>
                    <td class="align-middle text-center">{{lcc.CUSTOMER_VN}}</td>
                    <td class="align-middle text-center">{{lcc.LUCA_CODE}}</td>
                    <td class="align-middle text-center">{{lcc.PERSONEL_NAME}}</td>
                    <td class="align-middle text-center">{{formatDate(lcc.CREATED_AT)}}</td>
                    <td class="align-middle">
                      <button class="btn btn-sm btn-more-radius btn-primary" data-toggle="modal"
                        data-target="#uetdsModalUpdate" @click="selectLCC(index)">Güncelle</button>
                      <button class="btn btn-sm btn-more-radius btn-danger" data-toggle="modal" 
                        data-target="#uetdsDeleteConfirmation" @click="selectLCC(index)">Sil</button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </v-wait>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="uetdsModal" tabindex="-1"
      role="dialog" aria-labelledby="uetdsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uetdsModalLabel">Luca Kodu Ekleyin/Güncelleyin</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="lcc-inserting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Luca Kodu Kaydediliyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="out-retailer">Bayii Adı</label>
                    <select class="custom-select" id="out-retailer" v-model="selectedRetailer">
                      <option value="0" selected>Bayii seçiniz...</option>
                      <option v-for="(retailer, retailerIndex) in retailers"
                        v-bind:key="'retailer-'+ retailerIndex"
                        :value="retailer.RETAILER_ID.toString()">
                        {{retailer.RETAILER_NAME}}</option>
                      <option value="100" selected>Stok Dışı Cihazlar</option>
                      <option value="101" selected>ARIZA</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="out-customer">Müşteri Adı</label>
                    <cool-select v-model="selectedCustomer" id="out-customer" :items="foundCustomers" :loading="customerSearching"
                      disable-filtering-by-search  @select="onCustomerSelect"
                      @search="onCustomerSearch" item-text="CUSTOMER_TITLE" placeholder="Müşteri...">
                      <template slot="no-data">Müşteri bulunamadı</template>
                      <div slot="item" class="search-slot-item" slot-scope="{ item }">
                        <p class="text-truncate">{{item.CUSTOMER_TITLE}}</p>
                        <small class="text-primary" >Müşteri Kodu : {{item.CUSTOMER_ID}}</small>
                      </div>
                    </cool-select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="vehicleName">LUCA KODU</label>
                    <input type="text" class="form-control" v-model="newLCC.lucaCode" id="vehicleName">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="addLCC()" class="btn btn-success">Luca Kodu Ekle/Güncelle</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="uetdsModalUpdate" tabindex="-1"
      role="dialog" aria-labelledby="uetdsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uetdsModalLabel">Luca Kodu Ekleyin/Güncelleyin</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="lcc-inserting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Luca Kodu Kaydediliyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="out-retailer">Bayii Adı</label>
                    <input type="text" disabled class="form-control" :value="newLCC.retailerName" id="out-retailer">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="out-customer">Müşteri Adı</label>
                    <input type="text" disabled class="form-control" :value="newLCC.customerTitle" id="out-customer">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="vehicleName">LUCA KODU</label>
                    <input type="text" class="form-control" v-model="newLCC.lucaCode" id="vehicleName">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="addLCC()" class="btn btn-success">Luca Kodu Ekle/Güncelle</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="uetdsDeleteConfirmation" tabindex="-1"
      role="dialog" aria-labelledby="uetdsDeleteConfirmationLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uetdsDeleteConfirmationLabel">Luca Kodunu Sil</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="lcc-deleting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Luca Kodu Siliniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="unitPriceListId">BAYİİ</label>
                    <input type="text" disabled class="form-control" v-model="newLCC.retailerName" id="customerTitle">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="customerTitle">MÜŞTERİ</label>
                    <input type="text" disabled class="form-control" v-model="newLCC.customerTitle" id="customerTitle">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="vehicleName">LUCA KODU</label>
                    <input type="text" disabled class="form-control" v-model="newLCC.lucaCode" id="vehicleName">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="deleteLCC()" class="btn btn-danger">Luca Kodunu Sil</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { CoolSelect } from 'vue-cool-select'

export default {
  name: 'LCCPage',
  components: {
    Datepicker,
    CoolSelect
  },
  data () {
    return {
      messageText: '',
      retailers:[],
      selectedRetailer: {
        RETAILER_ID: 0,
        RETAILER_NAME: ''
      },
      customerSearching: false,
      foundCustomers: [],
      starCounts: [],
      selectedCustomer: {},
      selectedLCCId: 0,
      selectedLCC: {},
      newLCC: {
        id: 0,
        customerId: 0,
        lucaCode: '',
      },
      lccData: [],
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      },
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY HH:mm');
    },
    async onCustomerSearch(query) {
      if(!query || query.length < 4) {
        this.foundCustomers = []
        this.customerSearching = false
        return
      }

      this.customerSearching = true

      let jsonReq = {}
      jsonReq.SessionId = this.getSessionId
      jsonReq.SearchFilter = query
      jsonReq.Retailer = this.selectedRetailer

      console.log(jsonReq);

      await axios.post('/api/uruncikis/musteri-ara?sessionid=' + jsonReq.SessionId + 
        "&searchFilter=" + jsonReq.SearchFilter + "&retailer=" + jsonReq.Retailer, jsonReq)
      .then(response => {
        this.foundCustomers = response.data
        this.customerSearching = false
      })
      .catch(err => this.customerSearching = false)
      
    },
    async onCustomerSelect(item) {
      console.log('onCustomerSelect')
      console.log(item)
      console.log(this.selectedCustomer.CUSTOMER_ID + " - " + this.selectedCustomer.CUSTOMER_TITLE)

      this.newLCC.customerId = this.selectedCustomer.CUSTOMER_ID
      this.newLCC.customerTitle = this.selectedCustomer.CUSTOMER_TITLE
    },
    async getRetailers() {
      await axios.get('/api/a1/retailers')
      .then(response => {
        this.retailers = response.data
      })
      .catch(err => console.log(err))
    },
    groupStars() {
      const grouped = Object.groupBy(this.lccData, lcc => lcc.PERSONEL_NAME);

      let counts = Object.entries(grouped).map(([personel, lccs]) => ({
        personel: personel,
        count: lccs.length
      }));

      counts = counts.sort((a, b) => b.count - a.count);

      this.starCounts = counts;
    },
    getLCCData() {
      this.$wait.start('lcc-data-loading');

      axios
      .get('/api/lucaCustomerCodes')
      .then(response => {
        this.lccData = response.data
        this.groupStars()
        this.$wait.end('lcc-data-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('lcc-data-loading')
      })
    },
    addLCC() {
      this.$wait.start('lcc-inserting');

      console.log('lcc to be added/updated: ', this.newLCC)
      
      axios
      .post('/api/lucaCustomerCodes', this.newLCC)
      .then(response => {
        this.$wait.end('lcc-inserting')
        this.getLCCData()

        this.selectedLCC = null;
        this.selectedLCCId = 0;

        this.newLCC.id = 0;
        this.newLCC.customerId = 0
        this.newLCC.customerTitle = ''
        this.newLCC.retailerId = 0
        this.newLCC.retailerName = ''
        this.newLCC.lucaCode = ''
        this.newLCC.customerVd = ''
        this.newLCC.customerVn = ''

        $('#uetdsModal').modal('hide')
        $('#uetdsModalUpdate').modal('hide')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('lcc-inserting')
      })
    },
    deleteLCC() {      
      axios
      .delete('/api/lucaCustomerCodes/' + this.selectedLCCId)
      .then(response => {
        this.$wait.end('lcc-deleting')
        this.getLCCData()

        this.newLCC.id = 0;
        this.newLCC.customerId = 0
        this.newLCC.customerTitle = ''
        this.newLCC.retailerId = 0
        this.newLCC.retailerName = ''
        this.newLCC.lucaCode = ''
        this.newLCC.customerVd = ''
        this.newLCC.customerVn = ''

        $('#uetdsDeleteConfirmation').modal('hide')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('lcc-deleting')
      })
    },
    selectLCC(index) {
      this.selectedLCCId = this.lccData[index].ID
      this.selectedLCC = this.lccData[index]

      this.newLCC.id = this.selectedLCC.ID
      this.newLCC.customerId = this.selectedLCC.CUSTOMER_ID
      this.newLCC.customerTitle = this.selectedLCC.CUSTOMER_TITLE
      this.newLCC.retailerId = this.selectedLCC.RETAILER_ID
      this.newLCC.retailerName = this.selectedLCC.RETAILER_NAME
      this.newLCC.lucaCode = this.selectedLCC.LUCA_CODE
      this.newLCC.customerVd = this.selectedLCC.CUSTOMER_VD
      this.newLCC.customerVn = this.selectedLCC.CUSTOMER_VN
    },
  },
  mounted() {
    this.getRetailers()
    this.getLCCData()
  }
}
</script>

<style scoped>

  div.icon-global {
    position: absolute;
    z-index: 3;
    margin-left: -36px;
    margin-top: 24px;
    width: 30px;
    height: 30px;
    padding: 4px 4px 5px 4px;
    border-radius: 15px;
  }

  div.icon-global.bg-danger {
    margin-top: -6px !important;
  }

  div.icon-global i {
    color: #FFF;
  }

  .margin-negative {
    margin-bottom: -4px !important;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table { caption-side: top !important; }
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: 0.875rem;
  }

  td a.btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .text-truncated {
    display: block !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/LucaCustomerCodesPage.vue